import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row } from 'reactstrap';

class TextToApply extends Component {
  render() {
    return (
      <div className="page-text-to-apply">
        <Form>
          <Container>

            <Row className="mb-1 mb-md-4 mt-1">
              <Col>
                <h1 className="mb-3 mb-md-0 text-center text-md-left">Text to Apply Application</h1>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col xs={12}>
                <h4 className="lu-header-underline">Product/Service Information</h4>
              </Col>
              <Col md={6} lg={4}>
                <FormGroup>
                  <Label for="loanAmount">Loan Amount Requested</Label>
                  <Input type="text" name="loan-amount" id="loanAmount" />
                </FormGroup>
              </Col>
              <Col md={6} lg={4}>
                <FormGroup>
                  <Label for="dateOfService">Date of Service</Label>
                  <Input type="text" name="date-of-service" id="dateOfService" />
                </FormGroup>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col xs={12}>
                <h4 className="lu-header-underline">Applicant Personal Information</h4>
              </Col>
              <Col md={6} lg={4}>
                <FormGroup>
                  <Label for="firstName">First Name</Label>
                  <Input type="text" name="first-name" id="firstName" />
                </FormGroup>
              </Col>
              <Col md={6} lg={4}>
                <FormGroup>
                  <Label for="lastName">Last Name</Label>
                  <Input type="text" name="last-name" id="lastName" />
                </FormGroup>
              </Col>
              <Col md={6} lg={4}>
                <FormGroup className="dropdown-toggle">
                  <Label for="State">State of Residence</Label>
                  <Input type="select" name="state" id="state">
                    <option value=""></option>
                    <option value="alabama">Alabama</option>
                    <option value="alaska">Alaska</option>
                    <option value="arizona">Arizona</option>
                    <option value="arkansas">Arkansas</option>
                    <option value="california">California</option>
                    <option value="colorado">Colorado</option>
                    <option value="connecticut">Connecticut</option>
                    <option value="delaware">Delaware</option>
                    <option value="district-of-columbia">District of Columbia</option>
                    <option value="florida">Florida</option>
                    <option value="georgia">Georgia</option>
                    <option value="hawaii">Hawaii</option>
                    <option value="idaho">Idaho</option>
                    <option value="illinois">Illinois</option>
                    <option value="indiana">Indiana</option>
                    <option value="iowa">Iowa</option>
                    <option value="kansas">Kansas</option>
                    <option value="kentucky">Kentucky</option>
                    <option value="louisiana">Louisiana</option>
                    <option value="maine">Maine</option>
                    <option value="maryland">Maryland</option>
                    <option value="massachusetts">Massachusetts</option>
                    <option value="michigan">Michigan</option>
                    <option value="minnesota">Minnesota</option>
                    <option value="mississippi">Mississippi</option>
                    <option value="missouri">Missouri</option>
                    <option value="montana">Montana</option>
                    <option value="nebraska">Nebraska</option>
                    <option value="nevada">Nevada</option>
                    <option value="new-hampshire">New Hampshire</option>
                    <option value="new-jersey">New Jersey</option>
                    <option value="new-mexico">New Mexico</option>
                    <option value="new-york">New York</option>
                    <option value="north-carolina">North Carolina</option>
                    <option value="north-dakota">North Dakota</option>
                    <option value="ohio">Ohio</option>
                    <option value="oklahoma">Oklahoma</option>
                    <option value="oregon">Oregon</option>
                    <option value="pennsylvania">Pennsylvania</option>
                    <option value="rhode-island">Rhode Island</option>
                    <option value="south-carolina">South Carolina</option>
                    <option value="south-dakota">South Dakota</option>
                    <option value="tennessee">Tennessee</option>
                    <option value="texas">Texas</option>
                    <option value="utah">Utah</option>
                    <option value="vermont">Vermont</option>
                    <option value="virginia">Virginia</option>
                    <option value="washington">Washington</option>
                    <option value="west-virginia">West Virginia</option>
                    <option value="wisconsin">Wisconsin</option>
                    <option value="wyoming">Wyoming</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col md={6} lg={4}>
                <FormGroup>
                  <Label for="email">Email Address</Label>
                  <Input type="email" name="email" id="email" />
                </FormGroup>
              </Col>
              <Col md={6} lg={4}>
                <FormGroup>
                  <Label for="mobilePhone">Mobile Phone</Label>
                  <Input type="text" name="mobile-phone" id="mobilePhone" />
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col xs={12}>
                <h4 className="lu-header-underline">Applicant Authorization & Signature</h4>
              </Col>
              <Col xs={12} className="mb-3">
                <FormGroup check>
                  <Label check>
                    <Input type="checkbox" />{' '}
                    I agree and consent to the following terms:
                  </Label>
                </FormGroup>
              </Col>
              <Col xs={12}>
                <FormGroup>
                  <div className="form-control pt-1 pb-1">
                    <small>
                      By selecting the consent box above and clicking ‘Send Now’ you warrant and represent to LendingUSA that you are the named Applicant listed on this form and you authorize LendingUSA, its Lender(s), affiliated third parties and service providers to send up to 7 texts/week with follow up messages regarding this application, promotional loan product/services, and other marketing or information about LendingUSA, and/or its Lender(s) to the telephone number provided above using an autodialer, even if that number is on a federal or state do-not-call list. Consent is not a condition of applying for a loan. Your selecting of the consent box above and clicking ‘Send Now’ is your electronic signature agreeing to receive text messages. Call 800-994-6177 for a free paper copy of these terms. Reply HELP for help; Reply STOP to withdraw consent. Msg. and data rates may apply.<br />
                      <Link to="#">Terms of Use</Link> &nbsp;|&nbsp; <Link to="#">Privacy Policy</Link> &nbsp;|&nbsp; <Link to="#">Mobile Messaging Terms &amp; Conditions</Link>
                    </small>
                  </div>
                </FormGroup>
              </Col>
              <Col md={8} lg={6}>
                <FormGroup>
                  <Label for="signature">Applicant Signature</Label>
                  <Input type="text" name="signature" id="signature" />
                </FormGroup>
              </Col>
              <Col md={4} lg={2}>
                <FormGroup>
                  <Label for="signDate">Date</Label>
                  <Input type="text" name="sign-date" id="signDate" value="12/12/2018" readOnly />
                </FormGroup>
              </Col>
            </Row>

            <Row className="mb-4">
              <Col xs={12} className="text-center">
                <hr />
                <Button size="lg" color="primary">Send Application Text Now</Button>
              </Col>
            </Row>

          </Container>
        </Form>
      </div>
    )
  }
}

export default TextToApply;
